var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4993 22.3337H16.4993C20.666 22.3337 22.3327 20.667 22.3327 16.5003V11.5003C22.3327 7.33366 20.666 5.66699 16.4993 5.66699H11.4993C7.33268 5.66699 5.66602 7.33366 5.66602 11.5003V16.5003C5.66602 20.667 7.33268 22.3337 11.4993 22.3337Z",
    stroke: "#5F6060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.0004 11.4746L9.92539 13.5496C9.68372 13.7913 9.68372 14.1996 9.92539 14.4413L12.0004 16.5163",
    stroke: "#5F6060",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 11.4746L18.075 13.5496C18.3167 13.7913 18.3167 14.1996 18.075 14.4413L16 16.5163",
    stroke: "#5F6060",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 3.5,
    stroke: "#5F6060",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingIcon);
export default __webpack_public_path__ + "static/media/coding-icon.0d03b72fc47a1cf19f34bc43dc697dfb.svg";
export { ForwardRef as ReactComponent };